import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge Tailwind CSS class names intelligently.
 *
 * Combines clsx (conditional classes) with tailwind-merge (deduplication of
 * conflicting Tailwind utilities) so callers can pass arbitrary class values
 * without worrying about class order conflicts.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
